import { z } from 'zod'
import type { BaseCompany } from '~/domain/shared/company/models/Company'

export const BaseCompanyDTO = z.union([
  z.object({
    name: z.string().nullish(),
    company_name: z.string().nullish(),
    id: z.number()
  }),
  z.number()
])

export type BaseCompanyDTO = z.infer<typeof BaseCompanyDTO>

export function mapDTOToBaseCompany (dto: BaseCompanyDTO): BaseCompany {
  if (typeof dto === 'number') {
    throw new TypeError('BaseCompany should not receive numbers')
  }

  return {
    name: dto.name ?? dto.company_name ?? '',
    id: dto.id
  }
}

export function mapBaseCompanyToDTO (model: BaseCompany): number {
  return model.id!
}
